import React, { useMemo, useCallback } from 'react';
import { Card, Modal, SageClassnames } from '@kajabi/sage-react';

import { useResultContext } from 'common/components/CopyMagic/contexts';
import CategoryTitleInput from 'common/components/CopyMagic/generators/CourseOutline/components/CategoryTitleInput';
import PostTitleInput from 'common/components/CopyMagic/generators/CourseOutline/components/PostTitleInput';
import PostBodyInput from 'common/components/CopyMagic/generators/CourseOutline/components/PostBodyInput';

import { countResultCategoriesAndPosts } from 'common/components/CopyMagic/generators/CourseOutline/shared/dataHelpers';
import { CategoryResultType } from 'common/components/CopyMagic/generators/CourseOutline/CourseOutline.types';

const _key = (path: Array<any>) => path.join('_') + Math.floor(Math.random() * 100);

const ResultDisplay = () => {
  const { result } = useResultContext();

  // Re-render if the _count_ of categories and posts has changed
  const resultItemsCount = useMemo(() => countResultCategoriesAndPosts(result), [result]);
  const renderResultInputs = useCallback(() => {
    if (!result) return null;
    if (!('categories' in result)) return null;

    return result.categories.map(({ posts }: CategoryResultType, categoryIndex: number) => (
      <div className={SageClassnames.SPACERS.LG_BOTTOM} key={_key(['category', categoryIndex])}>
        <Card compact={true}>
          <CategoryTitleInput attributePath={['categories', categoryIndex, 'title']} />
          {posts.map((_, postIndex: number) => (
            <React.Fragment key={_key(['categories', categoryIndex, 'posts', postIndex])}>
              <Card.Divider fullBleed={true} />
              <PostTitleInput
                attributePath={['categories', categoryIndex, 'posts', postIndex, 'title']}
              />
              <PostBodyInput
                attributePath={['categories', categoryIndex, 'posts', postIndex, 'body']}
              />
            </React.Fragment>
          ))}
        </Card>
      </div>
    ));
  }, [resultItemsCount]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!result) return null;

  return <Modal.Body>{renderResultInputs()}</Modal.Body>;
};

export default ResultDisplay;
